import GeneralPropertyCard from "./GeneralPropertyCard";

export default GeneralPropertyCard;
